import AreYouSure from "./are-you-sure";

export default AreYouSure;
